<template>
<div>
  <div v-if="!atendimento" class="d-flex justify-content-center align-items-center flex-column mt-3">
    <az-loading msg="Carregando dados do laudo..." />
  </div>

  <div v-if="atendimento" class="w3-animate-opacity" :style="( ver_lista ? 'margin-left: 300px;' : '') + ( historico_direita ? 'margin-right: 300px; ' :  '' )">

    <div id="basevideo"></div>

    <ficha-paciente :paciente="atendimento.paciente" @atualizado="load()" :super_resumo="true" />

    <template v-if="false">
      <div class="row mb-0">
        <div class="col col-12 col-md-6 d-flex flex-md-row flex-column">
          <router-link
            v-if="false"
            class="btn btn-outline-primary mb-2 btn-sm mr-0 mr-md-2"
            :to="{ path: '/laudos/lista' }">
            Lista de Trabalho
          </router-link>
          <a href="#" @click.prevent="abrir_lista_de_trabalho()" class="btn btn-outline-primary mb-2 btn-sm mr-0 mr-md-2">
            <i class="fas fa-list"></i>
          </a>
          <a id="historico-prontuario" href="#" class="btn btn-outline-primary mb-2 btn-sm mr-0 mr-md-2" @click.prevent="abrir_lista ()"
            v-if="lista_pacientes && lista_pacientes.length > 0">
            {{ ver_lista ? 'Esconder' : 'Ver' }} Lista de Trabalho
            <span class="badge badge-primary ml-1">{{ lista_pacientes.length }}</span>
          </a>
          <a
            href="#"
            class="btn btn-outline-primary mb-2 btn-sm mr-0 mr-md-2"
            @click.prevent="historico ()">
            Ver Histórico do Prontuário
          </a>
          <button
            type="button"
            class="btn btn-outline-secondary mr-0 mr-md-2 mb-2 btn-sm"
            :disabled="true"
          >{{ getFormatDate(atendimento.dt_inicio,'DD/MM/YYYY') }}</button>
        </div>
        <div class="col col-12 col-md-6 d-flex flex-md-row flex-column justify-content-end">
          <template v-if="pode_alterar && !laudo_pronto">
              <!-- Reconhecimento de Voz -->
              <button
                  type="button"
                  class="btn btn-outline-success mr-0 mr-md-2 mb-2 btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Reconhecimento de Voz."
                  @click="reconhecer_voz()" v-if="false">
                  <i class="fas fa-comment-alt"></i>
              </button>

              <!-- Laudite -->
              <button
                v-if="laudite_company_token"
                type="button"
                class="btn btn-outline-success mr-0 mr-md-2 mb-2 btn-sm"
                data-toggle="tooltip" data-placement="top" title="Editor vs Laudite."
                @click="toggle_laudite()">
                {{ editor_laudite ? 'Editor' : 'Laudite' }}
              </button>

              <!-- Leorad -->
              <button
                v-if="leorad_token"
                type="button"
                class="btn btn-outline-success mr-0 mr-md-2 mb-2 btn-sm"
                data-toggle="tooltip" data-placement="top" title="Editor vs LeoRad."
                @click="toggle_leorad()">
                {{ editor_leorad ? 'Editor' : 'LeoRad' }}
              </button>

              <!-- Galeria de Imagens -->
              <button
                  type="button"
                  class="btn btn-outline-success mr-0 mr-md-2 mb-2 btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
                  @click="abrir_galeria_imagens()"
              >
                  <i class="fas fa-images"></i>
              </button>

              <!-- Resultados -->
              <button
                  type="button"
                  class="btn btn-outline-success mr-0 mr-md-2 mb-2 btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Resultados de Exames."
                  @click="resultados ()"
              >
                  <i class="fas fa-table"></i>
              </button>

              <!-- Lembretes -->
              <button
                  type="button"
                  class="btn btn-outline-secondary mr-0 mr-md-2 mb-2 btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao procedimento."
                  @click="lembrete ()"
              >
                  <i class="fas fa-thumbtack mr-2"></i>
                  <i class="fa fa-play"></i>
              </button>
              <button
                  type="button"
                  class="btn btn-outline-secondary mb-2 btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao paciente."
                  @click="$refs.lembretepac.editar()"
              >
                  <i class="fas fa-thumbtack mr-2"></i>
                  <i class="fas fa-user-injured"></i>
              </button>
          </template>
        </div>
      </div>
    </template>

    <!-- Pré Atendimento -->
    <pre-atendimento-view :marcacao="atendimento.marcacao" v-if="atendimento" :pode_editar="fila_laudo && fila_laudo.fl_anat_pat" @editar="editar_pre" :callback_preenchimento="preencher_formularios" />
    
    <!-- Arquivos da Marcação -->
    <div v-if="atendimento && atendimento.marcacao && atendimento.marcacao.arquivos.length">
      <p class="alert alert-primary">
        <span class="text-muted mr-2">Anexos do Atendimento:</span>
        <a :href="arq.arquivo.temporary_url" class="text-white"
          v-for="(arq, iax) in atendimento.marcacao.arquivos" :key="iax" target="_blank">
          <span class="badge badge-primary p-2 mr-2">
            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
            {{ arq.arquivo.st_titulo }}  
          </span>
        </a>
      </p>
    </div>

    <lembrete-paciente ref="lembretepac" v-model="atendimento.paciente" />

    <p class="alert alert-warning lead" v-if="atendimento.lembrete">
      <i class="fas fa-thumbtack mr-2" data-toggle="tooltip" data-placement="top" title="Lembrete do Atendimento"></i>
      {{ atendimento.lembrete.st_lembrete }}
    </p>

    <ul class="nav nav-tabs" id="myTab" role="tablist" v-if="tem_abas">
      <li class="nav-item" v-if="registro_pep">
        <a class="nav-link active" style="padding: 0.25rem 1rem" id="registro-tab" data-toggle="tab" href="#registro" role="tab" @click="index = -1">
          <span class="small">
            {{ registro_pep.modelo ? registro_pep.modelo.st_modelo_prontuario : 'Notas' }}
          </span>
        </a>
      </li>
      <li class="nav-item" v-for="(item, index) in atendimento.atendimento_procedimentos" :key="index">
        <a class="nav-link" style="padding: 0.25rem 1rem" :class="( index || registro_pep ) ? '' : 'active'" :id="'t-' + index + 'tab'" data-toggle="tab" :href="'#t-' + index" role="tab">
          <span class="small">
            {{ item.procedimento.st_procedimento }}
          </span>
        </a>
      </li>
      <li class="nav-item" v-if="1 == 0 && pode_alterar && !atendimento.fl_avulso">
        <!-- data-toggle="tab" href="#add" role="tab"  -->
        <a class="nav-link" id="add-tab" href="#" @click.prevent="addProcedimento ()">
          <i class="fas fa-plus"></i>
        </a>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade"
        :class="( index || registro_pep ) ? '' : 'show active'"
        :id="'t-' + index"
        role="tabpanel"
        aria-labelledby="home-tab"
        v-for="(item, index) in atendimento.atendimento_procedimentos"
        :key="index">

        <div class="mb-3" v-if="item.laudo">
          <div class="card">
            <div class="card-body" :class="( editor_laudite || editor_leorad ? 'p-0' : '' )">

                <!-- Revisão -->

                <div class="alert alert-secondary py-1 px-2 small" v-if="item.revisor">
                    Laudado por: {{ item.medico ? item.medico.st_nome_exibicao : atendimento.medico.st_nome_exibicao }} | 
                    Revisado por: {{ item.revisor.st_nome_exibicao }}
                </div>

                <div class="alert alert-warning py-1 px-2 small" v-else-if="item.laudo.status_laudo.fl_revisao">
                    <strong>Aguardando Revisão</strong>
                </div>

                <!-- Fim Revisão -->

                <div v-if="item.laudo.doc_certificado_link" class="d-flex flex-column mb-3">
                    <a :href="item.laudo.doc_certificado_link" class="btn btn-outline-primary" target="_blank">
                        <i class="fa fa-print mr-2" aria-hidden="true"></i>
                        Laudo Assinado
                    </a>
                </div>

              <div v-else-if="( !pode_alterar || laudo_pronto ) && ( item.laudo.unificado )" class="d-flex flex-column mb-3">
                <a href="#" class="btn btn-outline-primary" @click="abrir_outro(item.laudo.unificado)">
                  <i class="fa fa-print mr-2" aria-hidden="true"></i>
                  Acessar Laudo
                </a>
              </div>

              <div v-else-if="( !pode_alterar || laudo_pronto ) && ( !item.laudo.arquivos || !item.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length )" class="d-flex flex-column mb-3">
                <a href="#" class="btn btn-outline-primary" @click="imprimir(item.laudo)">
                  <i class="fa fa-print mr-2" aria-hidden="true"></i>
                  Imprimir Laudo
                </a>
              </div>

              <template v-if="item.laudo.fl_unificar">
                Laudo unificado.
              </template>

              <template v-else-if="pode_alterar && !laudo_pronto && editor_laudite">
                <az-laudite :fullscreen="editor_laudite_fullscreen" @toggle="toggle_laudite_fullscreen" :paciente="atendimento.paciente.st_nome" :company_token="laudite_company_token" :content="extrairContent(item.laudo)" 
                    @salvarLaudo="salvarLaudoLaudite" @salvarLaudoNext="salvarLaudoLauditeNext" :url="laudite_url" 
                    @autoSave="autoSaveLaudite" @autoSaveGetHtml="autoSaveLauditeGetHtml" ref="lauditeRef"
                    :posx="tem_abas ? 240 : 210" >
                    <template v-slot:buttons>
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm mr-1"
                            :class="item.laudo && item.laudo.st_estudo_andamento ? 'btn-outline-success' : ''"
                            v-if="item.st_pacs == 'OK'"
                            data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                            @click="open_url_estudo(item)"
                        >
                            <i class="fas fa-x-ray"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-success btn-sm mr-1"
                            data-toggle="tooltip" data-placement="botton" title="Visualizar Laudo"
                            @click="imprimir(item.laudo)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                    </template>
                </az-laudite>
              </template>

              <template v-else-if="pode_alterar && !laudo_pronto &&editor_leorad">
                <az-leo-rad :fullscreen="editor_leorad_fullscreen" @toggle="toggle_leorad_fullscreen" :paciente="atendimento.paciente.st_nome" :company_token="laudite_company_token" :content="extrairContent(item.laudo)" 
                    @salvarLaudo="salvarLaudoLeoRad" @salvarLaudoNext="salvarLaudoLeoRadNext" :url="leorad_url" 
                    @autoSave="autoSaveLeoRad" 
                    :posx="tem_abas ? 240 : 210" >
                    <template v-slot:buttons>
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm mr-1"
                            :class="item.laudo && item.laudo.st_estudo_andamento ? 'btn-outline-success' : ''"
                            v-if="item.st_pacs == 'OK'"
                            data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                            @click="open_url_estudo(item)"
                        >
                            <i class="fas fa-x-ray"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-success btn-sm mr-1"
                            data-toggle="tooltip" data-placement="botton" title="Visualizar Laudo"
                            @click="imprimir(item.laudo)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                    </template>
                </az-leo-rad>
              </template>

              <template v-else>

                <template v-if="1==0 && item.laudo.laudo_entregas && item.laudo.laudo_entregas.length">
                  <div class="alert alert-info" v-for="(entrega, iex) in item.laudo.laudo_entregas" :key="'E' + iex">
                    Entrega realizada para {{ entrega.st_nome_recebedor }} 
                    em {{ $util.getFormatDate(entrega.created_at) }} às {{ entrega.created_at.substr(11,5) }}
                    <div>Por: {{ entrega.usuario.st_login }}</div>
                    <div class="small text-muted">{{ entrega.st_local }}</div>
                  </div>
                </template>

                <anexar-laudo-externo :laudo_arq="item.laudo" :pode_alterar="pode_alterar" @refresh="load()" :tem_partes="( item.laudo && item.laudo.partes && item.laudo.partes.length )"/>

                <template v-if="!( item.laudo.arquivos && item.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo' && arq.st_tipo_especial != 'audio').length )">
                    <laudo-editor 
                        ref="editor"
                        :modelo_revisado="modelo_revisado"
                        v-model="item.laudo" 
                        :fila="fila_laudo"
                        :textos="textos_padrao" 
                        :validate="validate"
                        :atendimento="atendimento" 
                        :atendimento_procedimento="item" 
                        :pode_alterar="pode_alterar && !laudo_pronto && !item.laudo.doc_certificado_link" 
                        :outros_laudos="outros_laudos" />
                </template>

              </template>

            </div>
          </div>

          <pre v-if="1 == 0">{{ item.laudo }}</pre>


          <procedimento-complementar-a-p 
            ref="procComp" 
            :fila_laudo="fila_laudo"
            :atp="item" 
            :atendimento="atendimento"
            @assinar="assinar"
            @status="laudo_status"
            @refresh="load()" />

          <!-- Compartilhamentos -->
          <div class="card mt-3" v-if="item.laudo.tarefas">
            <div class="card-header d-flex justify-content-between">
                <div>
                    Compartilhamentos
                </div>
                <div>
                    <a href="#" class="card-link" @click.prevent="compartilhar(item.laudo)">
                        <i class="fa fa-share" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(tarefa, itx) in item.laudo.tarefas" :key="itx">
                <div>{{ ( tarefa.usuario && tarefa.usuario.pessoa ) ? tarefa.usuario.pessoa.search : '' }}</div>
                <div>
                    <a href="#" @click.prevent="abrir_contatos(tarefa)">
                        <i class="fa-solid fa-circle-check fa-fw text-success mr-2" v-if="tarefa.fl_feita"></i>
                        <i class="fa-solid fa-circle-question fa-fw text-primary mr-2" v-else></i>
                        {{ tarefa.st_descricao }}
                    </a>

                    <ul class="list-group small mt-2" v-if="tarefa.contatos && tarefa.contatos.length">
                        <li class="list-group-item p-2" v-for="(contato, idx) in tarefa.contatos" :key="idx"
                            :class="!idx ? 'list-group-item-info' : ''">
                            <span class="mr-3">{{ contato.contato_status.search }}</span>
                            <span class="text-muted">{{ contato.usuario.st_login }} em {{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.substr(11,5) }}</span>
                            <div v-if="contato.dt_referencia">Referência: {{ $util.getFormatDate(contato.dt_referencia) }}</div>
                            <div style="white-space: pre-wrap;">{{ contato.st_observacoes }}</div>
                        </li>
                    </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="mb-3" v-else>
          <div class="alert alert-light">
            <button class="btn btn-outline-danger btn-sm ml-3" type="button">Remover</button>
          </div>
        </div>

        <div>&nbsp;</div>

        <!-- Menu de Opções -->

        <nav class="navbar fixed-bottom navbar-light bg-light">
          <div class="d-flex">
            <div>
                <a href="#" @click.prevent="abrir_lista_de_trabalho()" class="btn btn-outline-primary btn-sm mr-1" data-toggle="tooltip" data-placement="top" title="Retornar a lista de trabalho">
                    <i class="fas fa-list"></i>
                </a>
                
                <a id="historico-prontuario" href="#" class="btn btn-outline-primary btn-sm mr-1" @click.prevent="abrir_lista ()" v-if="lista_pacientes && lista_pacientes.length > 0"
                    data-toggle="tooltip" data-placement="top" :title="(ver_lista ? 'Esconder' : 'Ver') + ' lista lateral'">
                    <i class="fa-solid fa-sidebar"></i>
                    <span v-if="false">{{ ver_lista ? 'Esconder' : 'Ver' }} Lista</span>
                    <span class="badge badge-primary ml-1">{{ lista_pacientes.length }}</span>
                </a>

                <a href="#" class="btn btn-outline-primary btn-sm mr-1" @click.prevent="historico ()" data-toggle="tooltip" data-placement="top" title="Histórico do Paciente">
                    <i class="fa-solid fa-id-badge"></i>
                    <span v-if="false">Histórico</span>
                </a>

                <a href="#" class="btn btn-outline-primary btn-sm mr-1" @click.prevent="abrir_historico (true)" data-toggle="tooltip" data-placement="top" title="Histórico Resumido">
                    <i class="fas fa-notes-medical"></i>
                </a>

                <a href="#" class="btn btn-outline-primary btn-sm mr-1" @click.prevent="ver_anexos_lateral ()" data-toggle="tooltip" data-placement="top" title="Ver anexos do atendimento na lateral.">
                    <i class="fa-solid fa-right-to-line"></i>
                </a>
            </div>
          
            <span v-if="item.laudo" class="small ml-2">
                <div>
                    {{ getFormatDate(atendimento.dt_inicio,'DD/MM/YYYY') }}
                    <span class="ml-2">{{ atendimento.medico.search }}</span>
                </div>

                <div>
                    {{ item.laudo.status_laudo.search }}
                    <span v-if="!tem_abas">
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ atendimento.atendimento_procedimentos[0].procedimento.st_procedimento }}

                        <span class="ml-2" v-if="outros_laudos && outros_laudos.length && fila_laudo && fila_laudo.fl_anat_pat">
                            <a href="#" @click.prevent="abrir_outro(atp_item.laudo)" v-for="(atp_item, aix) in outros_laudos" :key="aix" class="badge ml-1" :class="'badge-' + ( atp_item.laudo && atp_item.laudo.status_laudo ? atp_item.laudo.status_laudo.st_color : 'primary' )">
                                {{ atp_item.procedimento.st_sigla }}
                            </a>
                        </span>
                    </span>
                </div>
            </span>
          </div>

          <div class="mr-3 mr-md-0">
            <div class="progress">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>
            
            <template v-if="!pode_alterar">
              <!-- Visualizar Imagens do PACS -->
              <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  :class="item.laudo && item.laudo.st_estudo_andamento ? 'btn-outline-success' : ''"
                  v-if="item.st_pacs == 'OK'"
                  data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                  @click="open_url_estudo(item)">
                  <i class="fas fa-x-ray"></i>
              </button>

              <!-- Galeria de Imagens -->
              <button
                  type="button"
                  class="btn btn-outline-success btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
                  @click="abrir_galeria_imagens()">
                  <i class="fas fa-images"></i>
              </button>
            </template>

            <template v-else>
              <!-- Laudite -->
              <button
                v-if="editor_laudite"
                type="button"
                class="btn btn-outline-success btn-sm mr-1"
                data-toggle="tooltip" data-placement="top" title="Maximizar Laudite."
                @click="toggle_laudite_fullscreen()">
                <i class="fas fa-expand-alt"></i>    
              </button>
              <button
                v-if="!laudo_pronto && laudite_company_token"
                type="button"
                class="btn btn-outline-success btn-sm mr-1"
                data-toggle="tooltip" data-placement="top" title="Editor vs Laudite."
                @click="toggle_laudite()">
                {{ editor_laudite ? 'Editor' : 'Laudite' }}
              </button>

              <button
                v-if="editor_leorad"
                type="button"
                class="btn btn-outline-success btn-sm mr-1"
                data-toggle="tooltip" data-placement="top" title="Maximizar LeoRad."
                @click="toggle_leorad_fullscreen()">
                <i class="fas fa-expand-alt"></i>    
              </button>
              <button
                v-if="!laudo_pronto && leorad_token"
                type="button"
                class="btn btn-outline-success btn-sm mr-1"
                data-toggle="tooltip" data-placement="top" title="Editor vs LeoRad."
                @click="toggle_leorad()">
                {{ editor_leorad ? 'Editor' : 'LeoRad' }}
              </button>

              <!-- Assinar -->
              <template v-if="1==1 || ( !item.laudo.arquivos || !item.laudo.arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length )">
                <template v-if="$store.state.user.medico && item.laudo">
                  <button class="btn btn-sm btn-outline-success mr-1" type="button" @click="assinar()" v-if="!item.laudo.doc_certificado_link">
                    <i class="fas fa-signature mr-1"></i>
                  </button>
                  <button  v-else class="btn btn-sm btn-outline-danger mr-1" type="button" @click="cancelar_assinatura(item.laudo)">
                    <i class="fa fa-times mr-1" aria-hidden="true"></i>
                    Cancelar Assinatura
                  </button>
                </template>
              </template>

              <!-- Ações / Status -->
              <template v-if="fila_laudo && fila_laudo.lista_status && fila_laudo.lista_status.length  && !( pode_alterar && !laudo_pronto && ( editor_laudite || editor_leorad ) )">
                <template v-if="fila_laudo.lista_status.length > 7">
                    <span class="dropdown dropup fix-left mr-1">
                        <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                            Próximo
                        </button>
                        <div class="dropdown-menu dropdown-menu-scroll-lg">
                            <a class="dropdown-item" 
                                href="#"  
                                v-for="(status, isx) in ordenar_lista(fila_laudo.lista_status, 'st_acao')" 
                                :key="isx" 
                                @click.prevent="laudo_status(status)">
                                {{ status.st_acao ? status.st_acao : status.search }}
                            </a>
                        </div>
                    </span>
                </template>

                <template v-else>
                    <button type="button" class="btn btn-sm ml-1" :class="'btn-' + status.st_color" 
                        v-for="(status, isx) in fila_laudo.lista_status" :key="isx" @click="laudo_status(status)">
                        {{ status.st_acao ? status.st_acao : status.search }}
                    </button>
                </template>
              </template>

              <!-- Imagens Chave -->
              <button
                  type="button"
                  class="btn btn-outline-dark btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Imagens Chave."
                  v-if="editor_laudite"
                  @click="anexar_laudo(item.laudo)">
                  <i class="fa-solid fa-key"></i>
              </button>

              <!-- Gravador de audio -->
              <button
                  type="button"
                  class="btn btn-outline-danger btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Abrir gravador de audio."
                  @click="abrirGravadorAudio()">
                  <i class="fas fa-microphone"></i>
              </button>

              <!-- Visualizar Imagens do PACS -->
              <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  :class="item.laudo && item.laudo.st_estudo_andamento ? 'btn-outline-success' : ''"
                  v-if="item.st_pacs == 'OK'"
                  data-toggle="tooltip" data-placement="top" title="Visualizar Imagens do PACS"
                  @click="open_url_estudo(item)">
                  <i class="fas fa-x-ray"></i>
              </button>

              <button
                  v-if="editor_laudite"
                  type="button"
                  class="btn btn-outline-success btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Visualizar Laudo"
                  @click="imprimir(item.laudo)"
              >
                  <i class="fas fa-print"></i>
              </button>

              <!-- Galeria de Imagens -->
              <button
                  type="button"
                  class="btn btn-outline-success btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
                  @click="abrir_galeria_imagens()">
                  <i class="fas fa-images"></i>
              </button>

              <!-- Anexos do Atendimento -->
              <button class="btn btn-sm btn-outline-danger mr-1" type="button"
                @click="enviar_arquivo ()"
                data-toggle="tooltip" data-placement="top" title="Anexos do Atendimento">
                <i class="fas fa-paperclip"></i>
              </button>

              <!-- Resultados -->
              <button
                  type="button"
                  class="btn btn-outline-success btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Resultados de Exames."
                  @click="resultados ()"
              >
                  <i class="fas fa-table"></i>
              </button>

              <!-- Lembretes -->
              <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-1"
                  data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao procedimento."
                  @click="lembrete ()"
              >
                  <i class="fas fa-thumbtack mr-2"></i>
                  <i class="fa fa-play"></i>
              </button>
              <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao paciente."
                  @click="$refs.lembretepac.editar()">
                  <i class="fas fa-thumbtack mr-2"></i>
                  <i class="fas fa-user-injured"></i>
              </button>

            </template>
          </div>
        </nav>

        <div class="row mb-2" v-if="false && item && item.laudo">
            <div class="col col-12">
                <multiselect
                    class="w-100"
                    :options="options_classes"
                    v-model="item.laudo.js_classes"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag(item, $event)"
                    placeholder="Selecione uma classificação..."
                    selectLabel="Pressione [ENTER] para selecionar"
                    deselectLabel="Pressione [ENTER] para remover"
                    tagPlaceholder="Pressione [ENTER] para incluir"
                    selectedLabel="Selecionado">
                    <template slot="noOptions">
                        Nenhuma classificação criada.
                    </template>
                </multiselect>
            </div>
        </div>

        <div class="form-row mb-1" v-if="item && item.st_an">
          <div class="col col-12 col-md-6">
            <az-input
                sizing="sm"
                label="Accession Number"
                :compact="true"
                :edicao="false"
                v-model="item.st_an">
                <template v-slot:buttonposb>
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary" type="button" id="button-addon2"
                            @click="copiar_clipboard(item.st_an, 'Accession Number copiado para área de transferência.')">
                            <i class="fas fa-copy"></i>
                        </button>
                    </div>
                </template>
            </az-input>
          </div>

          <div class="col col-12 col-md-6">
            <az-input
                sizing="sm"
                label="Id do Paciente"
                :compact="true"
                :edicao="false"
                v-model="atendimento.id_paciente">
                <template v-slot:buttonposb>
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary" type="button" id="button-addon2"
                            @click="copiar_clipboard(atendimento.id_paciente, 'Id do paciente copiado para área de transferência.')">
                            <i class="fas fa-copy"></i>
                        </button>
                    </div>
                </template>
            </az-input>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" :class="registro_pep ? 'show active' : ''" id="registro" role="tabpanel">
        <registro-nota-pep 
          v-if="registro_pep"
          :validate="validate"
          v-model="registro_pep" 
          :marcacao="atendimento.marcacao"
          :atendimento_procedimento="atp_first"
          :id_paciente="atendimento.id_paciente"
          @refresh="load"
          :atendimento="atendimento" />
      </div>

    </div>

    <template v-if="outros_laudos && outros_laudos.length">
        <az-sub-title title="Outros"></az-sub-title>

        <ul class="list-group mb-3" v-if="fila || rota_voltar"> 
            <li class="list-group-item" :class="outro.laudo.fl_unificar ? 'list-group-item-danger' : ''" v-for="(outro, iox) in outros_laudos" :key="iox">
                <div class="d-flex justify-content-between">
                    <div>
                        <input 
                            type="checkbox" 
                            class="mr-3" 
                            v-if="outro.laudo"
                            v-model="outro.laudo.fl_unificar" 
                            :disabled="outro.laudo.status_laudo.fl_pronto || outro.laudo.status_laudo.fl_revisao" />

                        <a href="#" class="card-link" @click.prevent="abrir_outro(outro.laudo)">
                            {{ outro.procedimento.search }}
                        </a>
                        
                        <span class="badge ml-2" :class="'badge-' + outro.laudo.status_laudo.st_color" v-if="!rota_voltar">
                            {{ outro.laudo.status_laudo.search }}
                        </span>

                        <span class="badge badge-danger ml-3" v-if="outro.laudo.fl_unificar">UNIFICAR</span>

                        <div class="small text-muted ml-5" v-if="outro.st_regiao">{{ outro.st_regiao }}</div>
                    </div> 
                    <div v-if="outro.procedimento && outro.procedimento.tipo_anat_pat">
                        <div v-if="outro.amostra_atendimento_procedimentos && outro.amostra_atendimento_procedimentos.length">
                            {{ outro.amostra_atendimento_procedimentos.map(aap => aap.amostra.st_codigo).join(', ') }}
                        </div>
                        <div v-else>
                            Amostra não selecionada
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <div class="alert alert-danger" v-if="outros_laudos.filter(item => item.laudo && item.laudo.fl_unificar).length">
            <strong>Unificação de laudo com os procedimentos selecionados.</strong>
        </div>
    </template>

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text" id="inputGroup-sizing-sm">Papel</span>
      </div>
      <select class="form-control" id="page-size" type="select" v-model="pageSize">
        <option value="A4">A4</option>
        <option value="A4-T">A4 (Timbrado)</option>
        <option value="A4-NT">A4 (Não Timbrado)</option>
        <option value="A5">A5</option>
        <option value="A5-T">A5 (Timbrado)</option>
        <option value="A5-NT">A5 (Não Timbrado)</option>
      </select>
    </div>

    <br><br><br>

    <!-- Modal de Finalização de Atenimdento -->
    <div
      class="modal fade"
      id="finalizarAtendimentoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered2" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Finalizar Atendimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4>Confirma finalizar o atendimento?</h4>
            <div v-if="documentos_certificados && documentos_certificados.length">
              <az-input
                class="mt-3"
                type="checkbox-group"
                label="Enviar documentos assinados para o paciente."
                v-model="enviar_docs" />
              
              <az-input
                class="mt-3"
                type="email"
                label="e-mail"
                v-if="enviar_docs"
                v-model="atendimento.paciente.cadastro.st_email" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="finalizar ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="lembreteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Lembrete</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input type="textarea" v-model="st_lembrete" />
          </div>
          <div class="modal-footer">
            <az-submit color="outline-danger" @click="removerLembrete ()" v-if="atendimento.lembrete && atendimento.lembrete.id_lembrete">Remover</az-submit>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizarLembrete ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="addProcedimentoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Adicionar Procedimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="atendimento && novoProcedimento">
            <procedimentos
              ref="proced"
              :idMarcacao="atendimento.marcacao.id_marcacao"
              :consultorio="true"
              :validate="validate"
              :posUpdate="procedimentosIncluidos"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="incluirProcedimento ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div> 

    <!-- Modal -->
    <div class="modal fade" id="sharePrescrModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Compartilhar receita, requisição de exames e atestado com o paciente</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column">

              <div class="mb-2">
                <label class="form form-control">
                  <i class="far fa-envelope mr-2" aria-hidden="true"></i>
                  {{ ( atendimento && atendimento.paciente.cadastro.st_email ) ? atendimento.paciente.cadastro.st_email : 'Não disponível' }}
                </label>
                <label class="form form-control">
                  <i class="fa fa-mobile mr-2" aria-hidden="true"></i>
                  {{ ( atendimento && atendimento.paciente.cadastro.telefones.celular ) ? telefone(atendimento.paciente.cadastro.telefones.celular) : 'Não disponível' }}
                </label>
              </div>

              <button type="button" class="btn btn-outline-primary" @click="enviar_para_paciente()"
                v-if="atendimento && atendimento.paciente.cadastro.st_email">
                <i class="far fa-envelope mr-2"></i>
                Enviar por e-mail
              </button>
              <a class="btn btn-outline-info mt-2" href="#" @click.prevent="enviar_para_paciente_telegram()" target="_blank" 
                v-if="atendimento && atendimento.paciente.cadastro.st_telegram_chat_id">
                <i class="fab fa-telegram-plane mr-2"></i>
                Enviar pelo Telegram
              </a>
              <a class="btn btn-outline-success mt-2" :href="enviar_para_whatsapp()" target="_blank" 
                v-if="atendimento && atendimento.paciente.cadastro.telefones.celular">
                <i class="fa fa-whatsapp mr-2" aria-hidden="true"></i> Enviar pelo WhatsApp
              </a>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <assinar-p-e-p ref="assinador" />

    <resultados ref="resultados" name="edicao" />

    <speech-rec ref="speech" />

    <gallery-preview ref="gallery" />

    <pre class="alert alert-warning mb-5" v-if="1 == 0">{{ atendimento }}</pre>
    
    <az-audio-recorder ref="azAudioRec" @refresh="load()" model_type="laudo" :model_id="laudoId()" :name="'laudo_' + laudoId()" />

    <!-- Barra lateral de pacientes -->

    <!-- Barra histórico lateral -->

    <div class="sticky-sidebar bg-white w3-animate-left" style="width: 300px;" v-if="ver_lista">

      <az-loading msg="Carregando..." v-if="false && $store.state.loading && !historico_carregado" />

      <div class="px-2" v-else>

        <div>
          <az-input
            sizing="sm"
            icon="fa fa-search"
            placeholder="Pesquisar..."
            v-model="search_lista" 
            iiinput="conteudo = null; selecionado = null;">
            <template v-slot:buttonposb>
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_lista()">
                  <i class="fas fa-arrow-left"></i>
                </button>
              </div>
            </template>
          </az-input>
        </div>

        <div class="card overflow-auto" style="height: 72vh;">
          <div class="card-body p-0">
            <div class="list-group" v-show="lista_pacientes">
              <!-- Lista de Atendimentos -->
              <a href="#" class="list-group-item list-group-item-action small" 
                :class="( itemlista.id_laudo == id ) ? 'active' : ''" @click.prevent="selecionar(itemlista, iix)"
                v-for="(itemlista, iix) in lista_pacientes_exibicao" :key="iix" :id="'itemlista' + itemlista.id_laudo">
                <div class="strong">
                    <h5 class="strong mb-0">{{ itemlista.nome_paciente }}</h5>
                </div>
                <div>
                    {{ itemlista.nome_procedimento }}
                </div>
                <div>
                    {{ itemlista.nome_medico }}
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <span v-if="itemlista.dt_inclusao">
                      {{ getHumanDate(itemlista.dt_inclusao) }} 
                      <small class="ml-2">{{ getHumanDuration(itemlista.dt_inclusao) }}</small>
                    </span>
                  </div>
                  <div>
                    <span v-if="itemlista.sinalizador" class="mr-2 bg-light">
                        <i :class="( itemlista.sinalizador.st_icon ? itemlista.sinalizador.st_icon : 'fas fa-flag' ) + ' text-' + itemlista.sinalizador.st_cor"
                            :title="itemlista.sinalizador.search"></i>
                    </span>

                    <span v-if="itemlista.id_atendimento">
                      #{{ itemlista.id_atendimento }}
                    </span>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div title="Prazo">
                    <span v-if="itemlista.prazo">
                      <i class="fa-solid fa-hourglass-end mr-2"></i>
                      <span class="badge badge-warning" v-if="itemlista.prazo.slice(0,10) == $util.hoje()">{{ $util.getFormatDate(itemlista.prazo, 'DD/MM') }}</span>
                      <span class="badge badge-danger" v-else-if="itemlista.prazo.slice(0,10) < $util.hoje()">{{ $util.getFormatDate(itemlista.prazo, 'DD/MM') }}</span>
                      <span v-else class="badge badge-primary">{{ $util.getFormatDate(itemlista.prazo, 'DD/MM') }}</span>
                    </span>
                  </div>
                  <div>
                    <h5 class="mb-1 text-right" v-if="itemlista.status_laudo">
                      <span class="badge" :class="'badge-' + ( itemlista.status_laudo.st_color ? itemlista.status_laudo.st_color : 'light' )">
                        {{ itemlista.status_laudo.search }}
                      </span>
                    </h5>
                    <div class="small text-danger text-right" v-if="!itemlista.ativo">
                      Atendimento Cancelado
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!--item.laudo.arquivos-->

  <az-file-upload
    ref="uploadlaudo"
    :multiple="true"
    @refresh="carregar_arquivos()"
    :arquivos="laudo_arq ? laudo_arq.arquivos : []" 
    :model="laudo_arq"
    :parms="{ model_type: 'laudo', model_id: laudo_arq ? laudo_arq.id_laudo : null }" />

  <az-file-upload
    v-if="atendimento && atendimento.marcacao"
    ref="upload"
    :multiple="false"
    @refresh="carregar_arquivos_marcacao()"
    :arquivos="atendimento.marcacao.arquivos ? atendimento.marcacao.arquivos : []" 
    :parms="{ model_type: 'marcacao', model_id: atendimento.marcacao.id_marcacao }" />

  <registrar-contatos ref="regcontatos" @refresh="load()" titulo="Informações" />

  <!-- Compartilhar Laudo -->
  <compartilhar-laudo ref="compartilhar" @refresh="load()" />

  <!-- Amostras -->
  <amostras ref="amostras" @refresh="load()" />

  <!-- Histórico Lateral Resumido -->
  <historico-pep-micro 
    ref="historico" 
    :atendimento="atendimento"
    :force_laudos="true" 
    :callback_abrir_item="abrir_outro"
    @refresh="load()" 
    @fechar="abrir_historico" 
    v-if="historico_direita" />

    <!-- Modal Edição Formulário Status -->
    <div class="modal fade" id="formularioStatusModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="status_selec">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span v-if="status_selec">{{ status_selec.st_acao ? status_selec.st_acao : status_selec.search }}</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    
                    <!-- Formulário -->
                    <div v-if="status_selec && status_modelo && status_modelo.doc_pre_atend">

                        <az-sub-title :title="status_modelo.st_modelo_prontuario" />

                        <formulario 
                            :compact="status_modelo.doc_pre_atend.fl_compact"
                            v-model="status_modelo.doc_pre_atend.js_conteudo" 
                            :saved="true" 
                            :validate="validate"
                            mode="fixed"
                            :config="true" />

                    </div>

                    <!-- Responsáveis -->
                    <div v-if="resps" class="mt-3"> 

                        <az-sub-title title="Responsáveis" />
                        <laudo-usuario-form :change_status="true" :laudo="resps" :validate="validate" :status_selec="status_selec" />

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <az-submit v-if="status_selec && ( status_selec.fl_info_resp || status_modelo )" @click="laudo_status(status_selec, null, true)">Atualizar</az-submit>
                </div>
            </div>
        </div>
    </div>
   
</div>
</template>

<script>
import * as moment from "moment";
import $ from "jquery";
import _ from "lodash";
import FichaPaciente from "../../shared/FichaPaciente.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import Procedimentos from "../recepcao/Procedimentos.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import LembretePaciente from "../consultorio/LembretePaciente.vue";
import AssinarPEP from '../consultorio/AssinarPEP.vue';
import AzLoading from '../../util/AzLoading.vue';
import Resultados from '../consultorio/Resultados.vue';
import PreAtendimentoView from '../consultorio/PreAtendimentoView.vue';
//import VisualizarLaudoExterno from '../consultorio/VisualizarLaudoExterno.vue';
import SpeechRec from '../../shared/speech/SpeechRec.vue';
import GalleryPreview from '../../shared/gallery/GalleryPreview.vue';
import LaudoEditor from './LaudoEditor.vue';
import AzSubTitle from '../../util/AzSubTitle';
import AzFileUpload from "../../util/AzFileUpload.vue";
import Multiselect from 'vue-multiselect';
import AnexarLaudoExterno from './AnexarLaudoExterno.vue';
import RegistroNotaPep from '../consultorio/RegistroNotaPep.vue';
import AzLaudite from '../../shared/forms/AzLaudite.vue';
import AzLeoRad from '../../shared/forms/AzLeoRad.vue';
import AzAudioRecorder from "../../../components/util/AzAudioRecorder.vue";
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import CompartilharLaudo from './CompartilharLaudo.vue';
import HistoricoPepMicro from "../consultorio/HistoricoPepMicro.vue";
import ProcedimentoComplementarAP from './ProcedimentoComplementarAP.vue';
import Amostras from '../laboratorio/Amostras.vue';
import Formulario from '../consultorio/Formulario.vue';
import LaudoUsuarioForm from './LaudoUsuarioForm.vue';

export default {
  data() {
    return {
      id_atendimento: null,
      atendimento: null,
      teste: "",
      st_lembrete: "",
      tipo_lembrete: "A",
      novoProcedimento: "",
      tmaFim: "",
      tmaInterval: null,
      validate: false,
      video: false, 
      compartilhando: false, 
      order_set_stats: {}, 
      enviar_docs: true, 
      tratamento: "M", 
      motivo_encerramento: "", 
      timeout: null, 
      fila_laudo: null, 
      pageSize: this.$util.getCookie("page-size"),
      outros_laudos: [], 
      ver_lista: false, 
      search_lista: "", 
      lista_pacientes: null, 
      selecionado: null, 
      filtro_lista: null, 
      acao_anexar: false, 
      laudo_arq: null, 
      options_classes: [], 
      rota_voltar: null, 
      editor_laudite: false, 
      editor_laudite_fullscreen: false,
      laudite_company_token: "", 
      laudite_url: "", 
      laudite_debounce: null,
      historico_direita: false, 
      editor_leorad: false, 
      editor_leorad_fullscreen: false,
      leorad_token: "", 
      leorad_url: "", 
      leorad_debounce: null,
      status_selec: null, 
      status_modelo: null, 
      resps: null, 
      textos_padrao: null,
      pode_editar_revisao: false, 
      carregar_historico_ao_abrir: false, 
      modelo_revisado: null, 
    };
  },

  props: ["id", "fila"],

  components: {
    FichaPaciente,
    AzInput,
    AzSubmit,
    Procedimentos,
    LembretePaciente,
    AssinarPEP,
    AzLoading,
    Resultados,
    PreAtendimentoView,
    SpeechRec, 
    GalleryPreview,
    LaudoEditor,
    AzSubTitle, 
    AzFileUpload,
    Multiselect,
    //VisualizarLaudoExterno, 
    AnexarLaudoExterno,
    RegistroNotaPep,
    AzLaudite,
    AzAudioRecorder,
    RegistrarContatos, 
    CompartilharLaudo, 
    HistoricoPepMicro, 
    AzLeoRad,
    ProcedimentoComplementarAP, 
    Amostras, 
    Formulario, 
    LaudoUsuarioForm, 
  },

  watch: { 
    pageSize: function (newValue) { 
      this.$util.setCookie("page-size", newValue);
    },
  },

  computed: {
    tem_abas: function () { 
      return this.registro_pep || this.atendimento.atendimento_procedimentos.length > 1;
    },

    registro_pep: function () { 
      return _.first(this.atendimento.registros, reg => reg.fl_consultorio);
    },

    atp_first: function () { 
      return _.first(this.atendimento.atendimento_procedimentos);
    },

    lista_pacientes_exibicao: function () { 
      if ( !this.lista_pacientes )
        return [];
        
      if ( !this.search_lista )
        return this.lista_pacientes;

      if ( this.search_lista && this.search_lista.slice(0,1) == '#' && !isNaN( this.search_lista.slice(1) ) ) { 
        let id_atd = parseInt( this.search_lista.slice(1) );
        return this.lista_pacientes.filter( item => item.id_atendimento == id_atd );
      }

      let reg = this.$util.getregex(this.search_lista);
      return this.lista_pacientes.filter(item => item.id_laudo == this.id || reg.test(JSON.stringify(item)));
    },

    laudo_pronto: function () { 
      return this.atendimento.atendimento_procedimentos.find(item => item.laudo.status_laudo.fl_pronto || ( item.laudo.status_laudo.fl_revisao && !this.pode_editar_revisao ) ) ? true : false;
    },

    pode_alterar: function () { 
      if ( this.fila == 'vt' ) { 
        return false;
      }

      return ( this.atendimento 
        && this.atendimento.pode_alterar_prontuario 
        && !this.atendimento.pode_alterar_prontuario.pode ) ? false : true;
    },

    tempo: function() {
      if (!this.atendimento) return "";

      let fim = this.atendimento.medico_end
        ? this.atendimento.medico_end
        : this.tmaFim;

      if (fim) {
        let now = moment(
          this.atendimento.medico_end
            ? this.atendimento.medico_end
            : this.tmaFim,
          "HH:mm:ss"
        );
        let end = moment(this.atendimento.medico_start, "YYYY-MM-DD HH:mm:ss");
        let diff = now.diff(end);

        let duration = moment.utc(diff).format("HH:mm:ss");

        if ( duration.substr(0,3) == '00:' ) { 
          duration = duration.substr(3,5);
        }

        return duration;
      }

      return "";
    },

    documentos_certificados: function () {

      if ( !this.atendimento )
        return [];

      let lista = [];

      this.atendimento.atendimento_procedimentos.forEach(atp => {

        if ( atp.anamnese ) { 

            if ( atp.anamnese.receita ) { 
                atp.anamnese.receita.forEach(item => {
                    if ( item.doc_certificado ) {
                    lista.push(_.cloneDeep(item));
                    }
                });
            }

            if ( atp.anamnese.requisicao ) { 
                atp.anamnese.requisicao.forEach(item => {
                    if ( item.doc_certificado ) {
                    lista.push(_.cloneDeep(item));
                    }
                });
            }

            if ( atp.anamnese.atestados ) { 
                atp.anamnese.atestados.forEach(item => {
                    if ( item.doc_certificado ) {
                    lista.push(_.cloneDeep(item));
                    }
                });
            }

            if ( atp.anamnese.documentos ) { 
                atp.anamnese.documentos.forEach(item => {
                    if ( item.doc_certificado ) {
                    lista.push(_.cloneDeep(item));
                    }
                });
            }

        }
        
      });

      return lista;

    },

  },

  methods: {
    ver_anexos_lateral () { 
        if ( this.atendimento.marcacao.arquivos && this.atendimento.marcacao.arquivos.length ) { 
            if ( this.atendimento.marcacao.arquivos.find(arq => !arq.arquivo) ) { 
                this.carregar_arquivos_marcacao(
                    true, 
                    () => { 
                        this.$refs.upload.ver_conteudo(true);
                    }
                ); 
                return;
            }
            
        }

        this.$refs.upload.ver_conteudo(true);
        return;
    },

    preencher_formularios (campos, titulo) { 

      if ( !campos ) { 
        return; 
      }

      if ( !confirm("Confirma preencher o formulário com os dados de '" + titulo + "'?") ) { 
        return;
      }

      let valores = this.$utilform.obter_campos(campos);

      this.atendimento.atendimento_procedimentos.forEach(atp => { 
        if ( atp.anamnese && atp.anamnese.dados ) { 
          this.$utilform.preencher_campos(atp.anamnese.dados, valores);
        }

        if ( atp.laudo && atp.laudo.dados ) { 
          this.$utilform.preencher_campos(atp.laudo.dados, valores);
        }
      });

      this.$toast.add({
        severity: "success",
        summary: "Atualizar",
        detail: "Atualização realizada.",
        life: 3000
      });

    },
    editar_pre (doc_pre) { 
        console.log('refs', this.$refs);
        this.$refs.procComp[0].editar_pre(doc_pre);
    },

    ordenar_lista (lista, campo) { 
        return _.orderBy(lista, [campo], ['asc']);
    },

    abrir_amostras () { 
        this.$refs.amostras.abrir(this.atendimento.id_atendimento);
    },
    
    abrir_historico () { 
        this.historico_direita = !this.historico_direita;

        this.$util.setCookie('ld-hrd', this.historico_direita ? 'S' : '');

        if ( this.historico_direita ) { 
            this.$nextTick(() => {
                this.$refs.historico.abrir(this.atendimento.id_paciente);
            });
        }
    },

    compartilhar (laudo) { 
        this.$refs.compartilhar.abrir(laudo);
    },

    abrir_contatos (tarefa) { 
        let parm_tarefa = _.cloneDeep(tarefa);

        parm_tarefa.model = { 
            type: 'tarefa',
            id: tarefa.id_tarefa, 
        };

        this.$refs.regcontatos.editar(parm_tarefa);
    },

    copiar_clipboard (text, mensagem = null) {
      this.$util.copiar_clipboard(this, text, mensagem);
    },

    enviar_arquivo(parms) {
      this.$refs.upload.abrir(parms);
    },

    extrairContent(laudo) {
        if(!laudo || !laudo.dados || !laudo.dados.length) return '';

        return _.get(laudo, 'dados.0.value');
    },

    abrirGravadorAudio() {
        this.$refs.azAudioRec.abrir()
    },

    laudoId() {
        return _.get(this.atendimento, 'atendimento_procedimentos[0].laudo.id_laudo');
    },

    autoSaveLauditeGetHtml(data) {
        this.autoSaveLaudite(data, (laudo) => {
            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
        });
    },

    autoSaveLaudite(data, callback = null) {
        if (this.laudite_debounce) {
            clearTimeout(this.laudite_debounce);
        }

        this.laudite_debounce = setTimeout(() => {
            const item = _.get(this.atendimento, 'atendimento_procedimentos[0]');

            if(!item) return;

            item.laudo.fl_html = true;
            item.laudo.st_layout_impressao = null;
            item.laudo.dados = [
                {
                    "type": "rich",
                    "label": null,
                    "width": "12",
                    "value": data
                }
            ];
            let query = {
                q: [
                    {
                        name: "laudos.salvar",
                        id: "laudo_salvar",
                        parms: { ...item.laudo }
                    }
                ]
            };

            this.axios.post("/aql", query).then(res => {
                if (
                    res.data.laudo_salvar.status == 200 &&
                    (res.data.laudo_salvar.data == "OK" || res.data.laudo_salvar.data.status == "OK")
                ) {
                    // OK
                    if (callback) {
                        callback(item.laudo);
                    }
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Erro",
                        detail: "Falha ao salvar laudo.",
                        life: 3000
                    });
                }
            });
            clearTimeout(this.laudite_debounce);
        }, 300);
    },
    
    salvarLaudoLauditeNext(data) {
        this.salvarLaudoLaudite(data, true);
    },

    salvarLaudoLaudite(data, next = false) {
        const item = _.get(this.atendimento, 'atendimento_procedimentos[0]');

        if(!item) return;

        var pdf = null;
        var html = data.data;
        if(data.laudite && data.pdf)
        {
            pdf = data.pdf;
        } 

        // item.laudo.st_laudo = data;
        item.laudo.fl_html = true;
        item.laudo.st_layout_impressao = null;
        item.laudo.dados = [
            {
                "type": "rich",
                "label": null,
                "width": "12",
                "value": html,
            }
        ];

        if(pdf)
        {
            item.laudo.pdf = pdf;
        }

        let query = {
            q: [
                {
                    name: "laudos.salvar",
                    id: "laudo_salvar",
                    parms: { ...item.laudo }
                }
            ]
        };

        const base = this.axios.defaults.baseURL;
        const redir = (base.substr(0,5) == 'https')
          ? 'https://api-relatorio.klingo.app/api' 
          : '';

        console.log('redir: ' + redir);

        this.axios.post(redir + "/aql", query).then(res => {
            if (
                res.data.laudo_salvar.status == 200 &&
                res.data.laudo_salvar.data == "OK"
            ) {

                if(this.fila_laudo && this.fila_laudo.lista_status && this.fila_laudo.lista_status.length) {
                    const status = _.find(this.fila_laudo.lista_status,
                        s => s.fl_ativo && s.fl_pronto
                    );

                    if(status && status.fl_pronto) {
                        this.laudo_status(status, () => {

                            if (next) {

                                if (this.lista_pacientes && this.lista_pacientes.length) {
                                    let index = this.lista_pacientes.findIndex(item => item.id_laudo == this.id);
                                    if (index >= 0 && index + 1 < this.lista_pacientes.length) {
                                        const i = index + 1;
                                        this.selecionar(this.lista_pacientes[i], i);
                                        return;
                                    }
                                }

                            } 
                            
                            this.editor_laudite = false;
                            this.load();

                        });
                    } else {
                        console.log('status não encontrado ou pronto = false', this.fila_laudo.lista_status);
                    }
                } else {

                    this.$toast.add({
                        severity: "success",
                        summary: "Atualizar",
                        detail: "Laudo salvo com sucesso.",
                        life: 3000
                    });

                }


            }
        });

    },

    autoSaveLeoRad(data) {
        if (this.leorad_debounce) {
            clearTimeout(this.leorad_debounce);
        }

        this.leorad_debounce = setTimeout(() => {
            const item = _.get(this.atendimento, 'atendimento_procedimentos[0]');

            if(!item) return;

            item.laudo.fl_html = true;
            item.laudo.st_layout_impressao = null;
            item.laudo.dados = [
                {
                    "type": "rich",
                    "label": null,
                    "width": "12",
                    "value": data
                }
            ];
            let query = {
                q: [
                    {
                        name: "laudos.salvar",
                        id: "laudo_salvar",
                        parms: { ...item.laudo }
                    }
                ]
            };

            this.axios.post("/aql", query).then(res => {
                if (
                    res.data.laudo_salvar.status == 200 &&
                    (res.data.laudo_salvar.data == "OK" || res.data.laudo_salvar.data.status == "OK")
                ) {
                    // OK
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Erro",
                        detail: "Falha ao salvar laudo.",
                        life: 3000
                    });
                }
            });
            clearTimeout(this.leorad_debounce);
        }, 300);
    },
    
    salvarLaudoLeoRadNext(data) {
        this.salvarLaudoLeoRad(data, true);
    },

    salvarLaudoLeoRad(data, next = false) {
        const item = _.get(this.atendimento, 'atendimento_procedimentos[0]');

        if(!item) return;

        // item.laudo.st_laudo = data;
        item.laudo.fl_html = true;
        item.laudo.st_layout_impressao = null;
        item.laudo.dados = [
            {
                "type": "rich",
                "label": null,
                "width": "12",
                "value": data
            }
        ];
        let query = {
            q: [
                {
                    name: "laudos.salvar",
                    id: "laudo_salvar",
                    parms: { ...item.laudo }
                }
            ]
        };

        this.axios.post("/aql", query).then(res => {
            if (
                res.data.laudo_salvar.status == 200 &&
                res.data.laudo_salvar.data == "OK"
            ) {

                if(this.fila_laudo && this.fila_laudo.lista_status && this.fila_laudo.lista_status.length) {
                    const status = _.find(this.fila_laudo.lista_status,
                        s => s.fl_ativo && s.fl_pronto
                    );

                    if(status && status.fl_pronto) {
                        this.laudo_status(status, () => {

                            if (next) {

                                if (this.lista_pacientes && this.lista_pacientes.length) {
                                    let index = this.lista_pacientes.findIndex(item => item.id_laudo == this.id);
                                    if (index >= 0 && index + 1 < this.lista_pacientes.length) {
                                        const i = index + 1;
                                        this.selecionar(this.lista_pacientes[i], i);
                                        return;
                                    }
                                }

                            } 
                            
                            this.editor_leorad = false;
                            this.load();

                        });
                    } else {
                        console.log('status não encontrado ou pronto = false', this.fila_laudo.lista_status);
                    }
                } else {

                    this.$toast.add({
                        severity: "success",
                        summary: "Atualizar",
                        detail: "Laudo salvo com sucesso.",
                        life: 3000
                    });

                }


            }
        });

    },

    open_url_estudo(item, toast = true) {
        this.$util.load(this, {
            service: 'pep',
            func: 'dr_tis_url',
            redir_api: true,
            parms: {
                id_atendimento_procedimento: item.id_atendimento_procedimento,
                id_paciente: this.atendimento.id_paciente,
                toast: toast,
                is_host_public: (this.$util.getCookie('cn-hpvip') == 'S')
            },
            loadTo: (res) => {
                if(res && res.url) {
                    this.$root.$children[0].$refs.pacs_viewer.abrir(res);
                    // this.$util.pacs_open_window(res.url);
                } else if(!toast) {
                    let params = 'msg=Estudo não disponível no PACS: #' + this.atendimento.id_atendimento + ' / ' + item.st_an;
                    params = new URLSearchParams(params).toString();
                    this.$util.pacs_open_window_default(params);
                }
            }
        });
    },

    toggle_laudite() { 
      this.editor_laudite = !this.editor_laudite;
      this.$util.setCookie('laudite', this.editor_laudite ? 'S' : 'N');
    },

    toggle_leorad() { 
      this.editor_leorad = !this.editor_leorad;
      this.$util.setCookie('leorad', this.editor_leorad ? 'S' : 'N');
    },

    toggle_laudite_fullscreen() { 
      this.editor_laudite_fullscreen = !this.editor_laudite_fullscreen;
    },

    toggle_leorad_fullscreen() { 
      this.editor_leorad_fullscreen = !this.editor_leorad_fullscreen;
    },

    addTag (item, newTag) {
      this.options_classes.push(newTag);

      if ( !item.laudo.js_classes )
        item.laudo.js_classes = [];

      item.laudo.js_classes.push(newTag);
    },

    carregar_arquivos_marcacao (abrir = false, callback = null) { 

      if ( !this.atendimento || !this.atendimento.marcacao ) { 
        alert('Falha na identificação do atendimento.')
        return;
      }

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'arquivos',
        func: 'links',
        parms: { 
          id: this.atendimento.marcacao.id_marcacao, 
          type: 'marcacao',
        }
      })
      .then(res => { 
        this.atendimento.marcacao.arquivos = res;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.upload.abrir();
          });
        }

        if ( callback ) {
          callback();
        }
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });

    },

    carregar_arquivos (abrir = false) { 

      if ( !this.laudo_arq ) { 
        alert('Falha na identificação do laudo.')
        return;
      }

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'arquivos',
        func: 'links',
        parms: { 
          id: this.laudo_arq.id_laudo, 
          type: 'laudo',
        }
      })
      .then(res => { 
        this.laudo_arq.arquivos = res;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.uploadlaudo.abrir();
          });
        }
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });

    },
    
    anexar_laudo (laudo) { 
      this.acao_anexar = true;
      this.laudo_arq = laudo;

      this.$nextTick(() => {
        this.carregar_arquivos(true);
      });
    },

    getHumanDate(date) {
        return (
            moment(date, "YYYY-MM-DD").format("DD") +
            " de " +
            moment(date, "YYYY-MM-DD").format("MMMM") +
            (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
            ? ""
            : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
        );
    },

    getHumanDuration(date) {
        if (date.substr(0, 10) == this.$util.hoje()) 
            return "hoje";
        else
            return moment.duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje())).humanize(true);
    },

    abrir_lista () { 
      if ( this.ver_lista ) { 
        //this.conteudo = null;
        this.selecionado = null;
        this.ver_lista = false;
        return;
      }

      this.ver_lista = true;
    },

    selecionar(item, index) { 
      this.selecionado = index;

      if ( item ) {
        this.abrir_outro(item);
      }
    },

    abrir_outro(laudo) { 
      this.$router.replace({ path: '/laudos/' + laudo.id_laudo + '/' + ( this.fila ? this.fila : '' ) });
      this.atendimento = null;
      //this.id_atendimento = atendimento.id_atendimento;
      this.$nextTick(() => { 
        this.load();
      });
    },

    imprimir(laudo) { 
      // if(this.editor_laudite) {
      //   if (this.$refs.lauditeRef && this.$refs.lauditeRef[0]) {
      //     this.$refs.lauditeRef[0].imprimirLaudo(laudo);
      //   }
      //   return;
      // }

      this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true);
    },
 
    cancelar_assinatura (laudo) { 
      if ( !confirm('Confirmar cancelar a assinatura do laudo?') )
        return;

      this.$util.atualizar(this, { 
        service: 'laudos',
        func: 'cancelar_assinatura',
        dados: { 
          id_laudo: laudo.id_laudo, 
        },
        toast: true,
        callback: () => { 
          this.load();
        }
      })
    },

    tem_parte_em_edicao () { 

        if ( !this.atendimento || !this.atendimento.atendimento_procedimentos[0] || !this.atendimento.atendimento_procedimentos[0].laudo ) { 
            return false; 
        }

        let laudo = this.atendimento.atendimento_procedimentos[0].laudo;     

        if ( laudo.partes && laudo.partes.length ) { 

            let parte_em_edicao = laudo.partes.find(parte => parte.fl_edicao && parte.fl_ativo);

            if ( parte_em_edicao ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Existem partes do laudo em edição. Finalize a edição antes de alterar o status. \n \n"
                        + _.get(parte_em_edicao, 'modelo.search', ''),
                    life: 5000
                });

                const el = document.querySelector('.parte' + parte_em_edicao.id_laudo_item);

                if (el) {

                    const offset = 100; // pixels extras
                    const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset;

                    window.scrollTo({
                        top: y,
                        behavior: 'smooth'
                    });

                }

                console.log('em_edicao', parte_em_edicao);

                return parte_em_edicao; 

            }
            
        }

        return false;
    },

    laudo_status(status, callbackEvent = null, salvar_modelo = false) {

        let parte_em_edicao = this.tem_parte_em_edicao();

        if ( parte_em_edicao ) { 
            return; 
        }

        if ( !salvar_modelo ) { 
            this.status_selec = null; 
            this.status_modelo = null;
            this.resps = null; 
        }

        this.$util.atualizar(this, { 
            service: 'laudos',
            func: 'status',
            dados: { 
                id_laudo: this.id,
                id_status_laudo: status.id_status_laudo,
                outros: this.outros_laudos.map(laudo => { 
                    return { 
                        id_laudo: laudo.laudo.id_laudo,
                        fl_unificar: laudo.laudo.fl_unificar,
                        id_laudo_unificado: laudo.laudo.id_laudo_unificado, 
                    };
                }),
                teste: this.outros_laudos, 
                id_recepcao: this.$util.getCookie('id_recepcao'),
                local: this.$util.getCookie('local-chamada'),
                block_painel: this.$util.getCookie('nao-enviar-painel'),
                fila: ( this.fila && !isNaN(this.fila) ) ? this.fila : null,
                teste_modelo: true, 
                status_modelo: this.status_modelo, 
                resps: this.resps ? this.resps.resps : null,
            },
            callback: res => { 

                if ( res.modelo || res.info_resp ) { 
                    this.status_selec = status; 
                    this.status_modelo = res.modelo; 
                    this.resps = { resps: res.resps };
                    this.validate = false; 

                    $('#formularioStatusModal').modal('show');
                    return; 
                } else { 

                    $('#formularioStatusModal').modal('hide');
                }

                if ( res == 'OK' || res.id_status_laudo ) { 
                
                    if ( this.lista_pacientes && this.lista_pacientes.length ) { 
                        let index = this.lista_pacientes.findIndex(item => item.id_laudo == this.id);

                        if ( index >= 0 && index + 1 < this.lista_pacientes.length ) { 
                            if ( !this.ver_lista ) { 
                                this.ver_lista = true;
                            }

                            if ( index >= 0 && res && res.id_status_laudo ) {
                                this.lista_pacientes[index].status_laudo = res;
                        
                                if(!callbackEvent) {
                                    this.load();
                                }
                            }

                            if(callbackEvent) {
                                callbackEvent();
                            } 
                        
                            return;
                        }

                    }

                    if ( status.st_color.substr(0,7) == 'outline' ) { 
                        if(callbackEvent) {
                            this.abrir_lista_de_trabalho();
                        } else {
                            this.load();
                        }
                    } else { 
                        this.abrir_lista_de_trabalho();
                    }
                }
            }
        });

    },

    abrir_lista_de_trabalho() { 
      if ( this.rota_voltar ) { 
        this.$router.push({path: this.rota_voltar});
      } else { 
        this.$router.push({name: 'laudos-lista', params: { filtro: this.filtro_lista}});
      }
    },

    confirmar_encerramento() { 
      this.$util.atualizar(this, { 
        service: 'marcacoes',
        func: 'cancelar_recorrencias',
        dados: { 
          id_marcacao: this.atendimento.marcacao.id_marcacao,
          motivo: 'Tratamento encerrado por ' + this.$store.state.user.pessoa.st_nome, 
        },
        modal: 'recorrenciaModal',
        callback: () => { 
          this.atendimento.marcacao.recorrencias = [];
        }
      });

    },

    recorrencia() { 
      $('#recorrenciaModal').modal('show');
    },

    abrir_galeria_imagens() { 
      this.$refs.gallery.abrir(this.atendimento);
    },

    reconhecer_voz() { 
      this.$refs.speech.abrir();
    },

    resultados() { 
      this.$refs.resultados.abrir(this.atendimento);
    },

    telefone (telefone) { 
      if ( !telefone )
        return "";

      let textoAjustado = "(" + telefone.slice(0,2) + ") ";
      if(telefone.length == 11) {
        const parte1 = telefone.slice(2,7);
        const parte2 = telefone.slice(7,11);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`        
      } else {
        const parte1 = telefone.slice(2,6);
        const parte2 = telefone.slice(6,10);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`
      }

      return textoAjustado;
    },

    assinar (order = null) { 

        console.log('assinar');

        if ( order ) { 

            this.$refs.assinador.solicitar(
                order.id_anamnese,
                order.model.type,
                order.model.id,
                () => { 
                    this.load();
                }
            );

            return; 

        }

        if ( this.tem_parte_em_edicao() ) { 
            return; 
        }

        this.validate = true;

        this.$nextTick(() => {
      
            let invalids = $(".invalid");

            if (invalids.length && $(".invalid").is(":visible")) {

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Verificar preenchimento dos campos.",
                    life: 3000
                });

            } else { 

                this.validate = false;

                this.$refs.assinador.solicitar(
                    this.id,
                    'laudo',
                    this.id,
                    () => { 
                    this.load();
                    }
                );

            }

        });

    },

    enviar_para_paciente() {
    
      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'enviar_para_paciente',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
        },
        modal: "sharePrescrModal",
        callback: () => { 
          this.$toast.add({
            severity: "success",
            summary: "Atualizar",
            detail: "Documentos enviados para o paciente.",
            life: 3000
          });
        }
      });

    },

    enviar_para_paciente_telegram() { 

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'enviar_para_paciente',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
          telegram: true,
        },
        modal: "sharePrescrModal",
        callback: () => { 
          this.$toast.add({
            severity: "success",
            summary: "Atualizar",
            detail: "Documentos enviados para o paciente.",
            life: 3000
          });
        }
      });

    },

    enviar_para_whatsapp() { 

      let nl = "%0D%0A";
      let msg = "Prezado(a) ";
      let celular = "";

      let texto = this.documentos_certificados.reduce((total, item) => { 
          return total = total + item.doc_certificado_link + nl;
        }, "");

      msg = msg + this.atendimento.paciente.st_nome;
      celular = this.atendimento.paciente.cadastro.telefones.celular;
      
      if (!celular) {
        return "javascript:alert('Celular não disponível')";
      }

      celular = "55" + celular;

      msg = msg + nl;
      msg = msg + "Links para os documentos gerados no atendimento:" + nl;
      msg = msg + texto;

      return "https://wa.me/" + celular + "?text=" + msg;

    },

    enviarParaPaciente () { 
      this.compartilhando = true;
      this.$util.loadItem(this, { 
        service: "pacientes",
        id: this.atendimento.id_paciente,
      })
      .then(res => { 
        if ( res.cadastro && res.cadastro.st_email )
          this.atendimento.paciente.cadastro.st_email = res.cadastro.st_email;
          
        $('#sharePrescrModal').modal('show');
      })
      .finally(() => { 
        this.compartilhando = false;
      });
    },

    toggleVideo () { 
      this.video = !this.video;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },

    procedimentosIncluidos() {
      alert("procedimentosIncluidos");
    },

    startCronometro() {
      if (
        this.atendimento &&
        this.atendimento.medico_start &&
        !this.atendimento.medico_end
      ) {
        if (this.tmaInterval) {
          clearInterval(this.tmaInterval);
        }

        this.tmaInterval = setInterval(() => {
          this.tmaFim = moment().format("HH:mm:ss");
        }, 1000);
      }
    },

    removerProcedimento(item) {
      this.$util.atualizar(this, {
        service: "pep",
        func: "remover",
        dados: {
          id_atendimento_procedimento: item.id_atendimento_procedimento
        },
        callback: () => {
          this.load();
        }
      });
    },

    incluirProcedimento() {
      if (this.$refs.proced.temItemBloqueado()) {
        alert("Item sem cobertura pela operadora.");
        return;
      }

      this.$store.commit("loading", true);

      this.$refs.proced
        .atualizar()
        .then(res => {
          if (res && res.data.retorno.status == 200) {
            this.$util
              .loadItem(this, {
                service: "atendimentos",
                func: "iniciar",
                id: this.atendimento.id_atendimento
              })
              .then(res => {
                if (res) {
                  this.load();
                  $("#addProcedimentoModal").modal("hide");
                }
              });
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });

    },

    addProcedimento() {
      this.novoProcedimento = false;

      this.$nextTick(() => {

        this.novoProcedimento = true;

        this.$nextTick(() => {
          this.$refs.proced.carregar();
          $("#addProcedimentoModal").modal("show");
        });

      });
    },

    lembrete() {
      this.st_lembrete = this.atendimento.lembrete
        ? this.atendimento.lembrete.st_lembrete
        : "";

      $("#lembreteModal").modal("show");
    },

    atualizarLembrete() {
      let lembrete;

      if (this.tipo_lembrete == "P") {
        lembrete = {
          id_paciente: this.atendimento.id_paciente,
          st_lembrete: this.st_lembrete
        };

        this.$util.atualizar(this, {
          service: "pacientes",
          func: "lembrete",
          dados: lembrete,
          modal: "lembreteModal",
          callback: res => {
            this.atendimento.paciente.paciente_unidade.st_lembrete = res;
          }
        });
      } else {
        if (this.atendimento.lembrete) {
          lembrete = { ...this.atendimento.lembrete };
          lembrete.st_lembrete = this.st_lembrete;
        } else {
          lembrete = {
            id_lembrete: null,
            id_atendimento: this.atendimento.id_atendimento,
            st_lembrete: this.st_lembrete
          };
        }

        this.$util.atualizar(this, {
          service: "lembretes",
          dados: lembrete,
          modal: "lembreteModal",
          callback: res => {
            this.atendimento.lembrete = res;
          }
        });
      }
    },

    removerLembrete() {
      if (!confirm("Confirma remover lembrete?")) {
        return;
      }

      this.$util.remover(this, {
        service: "lembretes",
        dados: this.atendimento.lembrete,
        modal: "lembreteModal",
        callback: () => {
          this.atendimento.lembrete = null;
        }
      });
    },

    getFormatDate(date, format) {
      return moment(date, "YYYY-MM-DD").format(format);
    },
    historico() {
      this.$root.perfil(this.atendimento.paciente);
    },
    load() {
      if ( this.$refs.gallery ) { 
        this.$refs.gallery.refresh();
      }

      if ( _.get(this.atendimento, 'atendimento_procedimentos.0.laudo.id_laudo') != this.id ) { 
        this.textos_padrao = null;
      }

      this.modelo_revisado = null;

      this.$util.load(this, { 
          service: 'laudos',
          func: 'laudo',
          parms: { 
              id_laudo: this.id,
              fila: this.fila,
              textos: this.textos_padrao === null ? true : false, 
          },
          loadTo: res => { 
            this.atendimento = res.atd;
            this.fila_laudo = res.fila;
            this.outros_laudos = res.outros;
            this.laudite_company_token = res.laudite_company_token; 
            this.laudite_url = res.laudite_url; 
            this.leorad_token = res.leorad_token;
            this.leorad_url = res.leorad_url; 
            this.pode_editar_revisao = res.pode_editar_revisar;
            this.modelo_revisado = res.modelo_revisado;

            if ( this.carregar_historico_ao_abrir ) { 
                this.carregar_historico_ao_abrir = false; 
                this.$nextTick(() => { 
                    this.abrir_historico(); 
                });
            } else if ( this.historico_direita ) { 
                this.$nextTick(() => {
                    this.$refs.historico.abrir(this.atendimento.id_paciente);
                });
            }

            if ( res.textos ) { 
                this.textos_padrao = res.textos;
            }

            if ( this.lista_pacientes && this.lista_pacientes.length && this.outros_laudos ) { 

              this.outros_laudos.forEach(ol => { 
                
                let index = this.lista_pacientes.findIndex(item => item.id_laudo == ol.laudo.id_laudo);
  
                if ( index >= 0 ) { 
                  this.lista_pacientes[index].status_laudo = ol.laudo.status_laudo;
                }

              });

            }

            if ( this.laudite_company_token && this.laudite_url && !this.editor_laudite && this.pode_alterar && !this.laudo_pronto && this.fila != 'vt') { 
              this.editor_laudite = ( this.$util.getCookie('laudite') == 'S' );
            }

            if ( this.leorad_token && this.leorad_url && !this.editor_leorad && this.pode_alterar && !this.laudo_pronto && this.fila != 'vt') { 
              this.editor_leorad = ( this.$util.getCookie('leorad') == 'S' );
            }

            this.startCronometro();

            if ( !this.rota_voltar ) { 

              this.$store.commit("setBreadcrumb", [
                { name: "Laudos", path: "/laudos/lista" },
                { name: this.atendimento.paciente.st_nome + ' #' + this.atendimento.id_atendimento, path: "/laudos/lista" }
              ]);

            }

            const item = _.get(this.atendimento, 'atendimento_procedimentos[0]');
            if(item && item.st_pacs == 'OK') {
                if(this.$util.pacs_verifica_window_opened()) {
                    try {
                        this.$store.commit("loading", true);
                        this.open_url_estudo(item, false);
                    } finally {
                        this.$store.commit("loading", false);
                    }
                } else if (this.$util.getCookie('cn-aipl') == 'S') {
                   this.open_url_estudo(item, false)
                }
            } else if(this.$util.pacs_verifica_window_opened()) { 
                
                this.$util.pacs_open_window_default(); 

            }

            if (this.ver_lista) {
                this.$nextTick(() => { 
                    setTimeout(() => {
                        let el = document.getElementById('itemlista' + this.id);
                        if ( el ) { 
                            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }, 2000);
                });
            }
          }
      });
    },
    cancelarProntuario() { 
      if ( !confirm ('Confirma realizar o cancelamento desse atendimento? Isso irá cancelar o registro no prontuário.') )
        return;

      this.$util.remover(this, { 
        service: 'pep',
        dados: { 
          id_atendimento: this.atendimento.id_atendimento,
        },
        callback: () => { 
          this.$router.push({ name: 'consultorio' });
        }
      });
    },
    selecionarFinalizar() {
      $("#finalizarAtendimentoModal").modal("show");
    },
    finalizar() {
      this.$store.commit("loading", true);

      let enviar_docs = false;

      if ( this.documentos_certificados && this.documentos_certificados.length ) { 
        this.$util.setCookie('enviar-docs', this.enviar_docs, 365);
        enviar_docs = this.enviar_docs;
      }

      let query = {
        q: [
          {
            name: "atendimentos.finalizar",
            id: "iniciar",
            parms: {
              id: this.atendimento.id_atendimento,
              enviar_docs: enviar_docs, 
              email: this.atendimento.paciente.cadastro.st_email
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.iniciar.status == 200) {
            if (res.data.iniciar.data.id_etapa_atendimento == 7) {
              this.$store.commit("loading", false);
              $("#finalizarAtendimentoModal").modal("hide");
              this.$router.push({ name: "consultorio" });
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    }
  },

  mounted() {
    if (this.id) {
      this.id_atendimento = this.id;
      this.load();
    }

    if ( this.$route.params.lista ) { 
      this.lista_pacientes = this.$route.params.lista;
    }

    if ( this.$route.params.filtro ) { 
      this.filtro_lista = this.$route.params.filtro;
    }

    if ( this.$route.params.voltar ) { 

      this.rota_voltar = this.$route.params.voltar;

      let bc = this.$store.state.breadcrumb;

      if ( bc.length > 0 ) { 
          bc.push({ name: "Laudo" });
          this.$store.commit('setBreadcrumb', bc);
      }

    } else { 

      this.$store.commit("setBreadcrumb", [
        { name: "Laudos", path: "/laudos/lista" },
        { name: "Carregando...", path: "/laudos/lista" }
      ]);

    }

    if ( this.aa ) { 
      // this.$util.setCookie('laudite', this.editor_laudite ? 'S' : 'N');
    }

    if ( this.$util.getCookie('ld-hrd') == 'S' ) { 
        this.carregar_historico_ao_abrir = true; 
    }
 
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  },

  beforeDestroy() {
    this.$util.pacs_open_window_default();
  }


};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sticky-sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}

.no-padding card-body { 
  padding: 0 !important;
}

.dropup.fix-left .dropdown-menu {
  left: -10px;
}

</style>